
import {
  ComponentInternalInstance,
  defineComponent,
  getCurrentInstance,
  watch,
  ref
} from 'vue'
import { defineRule, useField } from 'vee-validate'
import { required } from '@vee-validate/rules'
import { useI18n } from 'vue-i18n'

defineRule('required', required)
export default defineComponent({
  props: {
    modelValue: {
      type: String
    },
    label: {
      type: String,
      default: 'formularios.patente.label'
    },
    placeholder: {
      type: String,
      default: 'formularios.patente.placeholder'
    },
    required: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()
    const instance = getCurrentInstance() as ComponentInternalInstance

    const {
      value: field,
      errorMessage,
      meta,
      resetField
    } = useField(
      'input-' + instance.uid.toString(),
      { required: props.required },
      {
        initialValue: props.modelValue,
        label: 'número de chasis'
      }
    )

    const validating = ref(false)

    watch(field, async (nuevoVin) => {
      emit('update:modelValue', nuevoVin)
    })
    
    return {
      t,
      field,
      errorMessage,
      meta,
      resetField,
      validating
    }
  }
})
